import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer = () => (
  <Box sx={{ backgroundColor: '#2d3e50', py: 2, textAlign: 'center', borderTop: '1px solid #475569', borderRadius: '8px', mt: 4 }}>
    <Typography variant="caption" color="white">
      © {new Date().getFullYear()} MineProd. All rights reserved.
    </Typography>
  </Box>
);

export default Footer;